import "./InstructionItem.scss";
import { useRef, useState } from "react";
import { IconSvg } from "../../../../../../../../../../utils/constants/icons/iconSvg.constant";
import { classNames } from "../../../../../../../../../../utils/helpers/classNames";

export const InstructionItem = () => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  return (
    <div
      className={classNames("instruction-item", { "instruction-item--open": isOpen })}
      onClick={() => setIsOpen((current) => !current)}
    >
      <div className="instruction-item__head">
        <div className="instruction-item__title">Title name</div>
        <div className="instruction-item__icon">
          <IconSvg tag="newArrow" />
        </div>
      </div>
      <div
        ref={contentRef}
        className="instruction-item__content"
        style={{
          maxHeight: isOpen ? `${contentRef?.current?.scrollHeight}px` : 0,
          marginBottom: isOpen ? 24 : 0
        }}
      >
        Lorem ipsum dolor sit amet consectetur.
        Tempor amet dui nunc felis dolor elementum
        mauris sit. Urna aliquet lobortis in at dui.
        Purus morbi tortor enim ac vestibulum sit leo.
        Diam magnis felis laoreet feugiat duis.
        Sit pretium nulla diam morbi et. Hendrerit
        sodales feugiat viverra vitae natoque nunc
        urna sagittis. Vitae magna magna enim mi ligula
        adipiscing diam. Morbi suspendisse justo dui
        interdum massa enim. Nibh netus est in ut rhoncus
        natoque. In vulputate orci est pellentesque tellus
        risus sit nisl. Leo nisi arcu ornare sem ante mauris
        ipsum purus.
      </div>
    </div>
  );
};
